module.exports = {"370404001":"坛山街道办","370404002":"吴林街道办","370404100":"古邵镇","370404101":"阴平镇","370404102":"底阁镇","370404103":"榴园镇","370404104":"峨山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370404.json
// module id = 1280
// module chunks = 0